'use client';

import type React from 'react';
import { useState } from 'react';

import { cn } from '@skybeam/shared-utils';

export type TabConfig = {
  label: string;
  videoUrl: string;
};

interface FeatureTabsProps {
  tabs: TabConfig[];
}

export const FeatureTabs: React.FC<FeatureTabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  return (
    <div className="flex w-full flex-col items-center gap-y-12.5">
      <div className="tablet:after:absolute tablet:after:right-0 tablet:after:bottom-0 tablet:after:left-0 tablet:after:h-px tablet:after:bg-[linear-gradient(90deg,transparent_0%,#034dd3_10%,#4d95ff_52.88%,#034dd3_90%,transparent_100%)] tablet:h-[43px] tablet:gap-x-6 relative flex min-h-[43px] w-full flex-wrap items-center justify-center gap-x-2.5">
        {tabs.map(({ label }) => {
          const isActive = activeTab === label;
          return (
            <div
              key={label}
              className={cn(
                'tablet:border-2 tablet:border-transparent tablet:text-base tablet:rounded-[3px] tablet:bg-transparent tablet:pt-2.5 tablet:pb-1.5 z-1 flex cursor-pointer rounded-md px-3.5 py-[7px] text-xs font-semibold transition-all duration-300 hover:text-white',
                isActive
                  ? 'tablet:border-b-white tablet:bg-transparent bg-white/32 text-white'
                  : 'text-blue-300',
              )}
              onClick={() => setActiveTab(label)}
            >
              {label}
            </div>
          );
        })}
      </div>

      <div className="desktop:h-[542px] tablet:h-[298px] laptop:h-[505px] laptop:max-w-[864px] tablet:aspect-520/298 desktop:max-w-[926px] aspect-272/380 h-[380px] w-full overflow-hidden rounded-lg shadow-xl">
        {tabs.map(({ label, videoUrl }) => {
          const isActive = activeTab === label;

          if (!isActive) return null;
          return (
            <div
              key={label}
              className={cn(
                'relative inset-0 bottom-0 size-full rounded-[10px] border-2 border-blue-50 transition-opacity duration-500',
                isActive ? 'z-10 opacity-100' : 'z-0 opacity-0',
              )}
            >
              <video
                className="tablet:object-contain size-full rounded-lg bg-white object-cover object-top"
                src={videoUrl}
                preload="auto"
                autoPlay
                muted
                loop
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
